<template>
    <div>
        <Header />
        <div class="flex">
          <div style="margin: 1rem 0rem;">Below is a sample of a text-to-speech IVR recording</div>
          <audio src="../assets/speech.mp3" controls />
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header';
export default {
  components: {
    Header
  }
};
</script>

<style>
.flex {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>